import { Navigate } from "react-router-dom";
import { useCrawlingChatbotAuth } from "./CrawlingChatbotAuthProvider";


const CrawlingChatbotPrivateRoute = ({children}) => {
    const authContext = useCrawlingChatbotAuth();

    // Safety check: if context is null, redirect to signin
    if (!authContext) {
        return <Navigate to="/crawling/signin" />
    }

    const { isCrawlingChatbotAuthenticated } = authContext;

    if (!isCrawlingChatbotAuthenticated) {
        return <Navigate to="/crawling/signin" />
    }

    return children;
}

export default CrawlingChatbotPrivateRoute;